import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { useTranslation } from 'react-i18next';
import Treatment from './DrugDosageDescription/Treatment.jsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _ from 'lodash';
const { API } = require('./../../config/' + process.env.REACT_APP_ENV);

const MobileTreatment = props => {
  const { dosage, form } = props.defaultKeys;
  const name = props?.drugInfo?.cmsData?.name;
  const { t } = useTranslation();
  return API.ALLOW_CONTENT_FULL_DATA ? (
    <div id="drugTreatmentMobile">
      {props.drugInfo.cmsData && props.drugInfo.cmsData.description && (
        <div className="drug-treatment-mobile">
          {!_.isEmpty(props.drugInfo.imageUrl) && (
            <LazyLoadImage
              className="drugImage"
              src={props.drugInfo.imageUrl}
              alt={`${name} coupon - ${name} ${dosage} ${form}`}
              height="104px"
              width="140px"
            />
          )}
          <div className="treatmentAbout">
            {' '}
            {t('About')}&nbsp;{`${name}`}
          </div>
          {!!props.doNotMarket && (
            <p className="controlled-flag">
              <a
                href="https://www.singlecare.com/blog/controlled-substances-act/"
                target="_blank"
                rel="noopener noreferrer"
                className="controller-substances-link"
              >
                <span>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {t('Controlled Substance')}
                </span>
              </a>
            </p>
          )}
          {documentToReactComponents(
            props.drugInfo.cmsData && props.drugInfo.cmsData.description
          )}
        </div>
      )}
    </div>
  ) : (
    props.drugInfo.drug && props.drugInfo.drug.treatment && (
      <div id="drugTreatmentMobile">
        <div className="drug-treatment-mobile">
          <div className="treatmentAbout">
            {' '}
            {t('About')}
            {`${name}`}
          </div>
          {!_.isEmpty(props.drugInfo.imageUrl) && (
            <div className="drugImage">
              <LazyLoadImage
                src={props.drugInfo.imageUrl}
                alt={`${name} coupon - ${name} ${dosage} ${form}`}
                height="104px"
                width="140px"
              />
            </div>
          )}
          {!!props.doNotMarket && (
            <p className="controlled-flag">
              <a
                href="https://www.singlecare.com/blog/controlled-substances-act/"
                target="_blank"
                rel="noopener noreferrer"
                className="controller-substances-link"
              >
                {t('Controlled Substance')}
              </a>
            </p>
          )}
          <Treatment
            drug={props.drugInfo.drug}
            doNotMarket={props.doNotMarket}
            lowestPrice={props.lowestPrice}
            replaceableVariables={props.drugInfo.replaceableVariables}
          />
        </div>
      </div>
    )
  );
};
export default React.memo(MobileTreatment);
